import React from 'react';
import ReactECharts from 'echarts-for-react';

function DoughnutChart({ item }) {
  // Extract labels and values from the data object
  const labels = Object.keys(item.data);
  const values = Object.values(item.data);

  const option = {
    title: {
      text: item.title.text || '',
      left: 'left',
    },
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      left: 'right',
    },
    series: [
      {
        // name: 'Data',
        type: 'pie',
        radius: ['35%', '70%'],
        data: item.data,
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
          },
          // itemStyle: {
          //   shadowBlur: 10,
          //   shadowOffsetX: 0,
          //   shadowColor: 'rgba(0, 0, 0, 0.5)',
          // },
        },
        labelLine: {
          show: false,
        },
      },
    ],
  };

  return (
    <div style={{ position: 'relative', width: 'auto', height: '400px' }}>
      <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
    </div>
  );
}

export default DoughnutChart;
